import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  BASE_URL_BEN,
  GET_COMPANIES_LIST_NEW,
  HEADERS_EXPORT_BEN,
} from "../component/API/apiUrls";

const LoadCompanies = () => {
  const [companiesList, setCompaniesList] = useState([]);
  const [companiesOptions, setCompaniesOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(BASE_URL_BEN + GET_COMPANIES_LIST_NEW, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.status === 200 && response.data) {
        setCompaniesList(response.data);

        // แปลงข้อมูลให้เหมาะกับ Select component
        const options = response.data.map((company) => ({
          value: company.id,
          label: company.company_name,
          data: company, // เก็บข้อมูลเต็มไว้ใช้งาน
        }));

        setCompaniesOptions(options);
        console.log("Companies loaded:", response.data);
      } else {
        setCompaniesList([]);
        setCompaniesOptions([]);
        message.warning("ไม่มีข้อมูลบริษัท");
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      setCompaniesList([]);
      setCompaniesOptions([]);
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูลบริษัท");
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    loadData();
  };

  return {
    companiesList, // ข้อมูลดิบทั้งหมด
    companiesOptions, // ข้อมูลสำหรับ Select
    loading, // สถานะการโหลด
    refreshData, // ฟังก์ชันรีเฟรชข้อมูล
  };
};

export default LoadCompanies;
